import React, { useRef, useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const DraggableDialogPaper = React.forwardRef((props, ref) => {
  const nodeRef = useRef(null);

  const setRefs = useCallback(
    (node) => {
      nodeRef.current = node;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );

  return (
    <Draggable
      nodeRef={nodeRef}
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={setRefs} />
    </Draggable>
  );
});

export default DraggableDialogPaper;
